import { render, staticRenderFns } from "./CustomFormItem.vue?vue&type=template&id=02272bd5"
import script from "./CustomFormItem.vue?vue&type=script&lang=js"
export * from "./CustomFormItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports